import React from 'react';
import PropTypes from 'prop-types';

import * as BlockTypes from '../block-types';

import './block.css';

function camelCase(original) {
  const parts = original.split('-');
  for (let i = 0; i < parts.length; i += 1) {
    parts[i] = parts[i][0].substr(0, 1).toUpperCase() + parts[i].substr(1).toLowerCase();
  }
  return parts.join('');
}

function renderBlock(block) {
  const type = block.get('type');
  const elementName = camelCase(type);
  if (typeof BlockTypes[elementName] !== 'undefined') {
    const BlockElement = BlockTypes[elementName];
    return <BlockElement block={block} />;
  }
  return <div>Block type &quot;{type}&quot; not found</div>;
}

const Block = ({ block }) => (
  <div className="block">
    {renderBlock(block)}
  </div>
);

Block.propTypes = {
  block: PropTypes.object.isRequired,
};

export default Block;



// WEBPACK FOOTER //
// ./src/components/blocks/block/index.jsx